import React, { useState, useEffect, useRef, useContext } from 'react';
import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import moment from 'moment';
import ExpenseDatePicker from './ExpenseDatePicker';
import { ExpenseStatusValuesEnum } from './ExpenseStatus.enum';
import { COLORS } from '../../../utils/Application_Constants';
import eventBus from './EventBus';
import { ValidationModeContext } from '../../../contexts/VendorPaymentValidationModeContext';
import ValidationModeEnum from './ValidationMode.enum';

const ExpenseServiceDate = (props) => {
    const { index, expense, mode, isViewOnly } = props;
    const { control, watch, errors, setValue, trigger } = useFormContext();
    const billType = watch(`expenseEntries[${index}].billType`);
    const expenseCategory = watch(`expenseEntries[${index}].category`);
    const expenseType = watch(`expenseEntries[${index}].type`);
    const validationMode = useContext(ValidationModeContext);
    const isMileage =
        expenseType && expenseCategory && expenseCategory === 'Travel' && expenseType === 'Mileage';
    const [required, setRequired] = useState({ required: true });
    const hasMounted = useRef(false);
    const previousBillTypeRef = useRef(null);
    const handleDateChange = (e) => {
        if (e && e.startOf('day')) {
            setValue(
                `expenseEntries[${index}].transactionDate`,
                e.startOf('day').format('YYYY-MM-DD')
            );
            eventBus.emit(`txnDateChanged${index}`, {
                data: e.startOf('day').format('YYYY-MM-DD'),
            });
        } else {
            setValue(`expenseEntries[${index}].transactionDate`, e);
            eventBus.emit(`txnDateChanged${index}`, { data: e });
        }
        trigger(`expenseEntries[${index}].transactionDate`);
    };

    useEffect(() => {
        const aDate = expense.transactionDate
            ? moment(expense.transactionDate).startOf('day').format('YYYY-MM-DD')
            : null;
        eventBus.emit(`txnDateChanged${index}`, { data: aDate });
    }, []);

    useEffect(() => {
        setRequired({
            required:
                expense?.status !== ExpenseStatusValuesEnum.Abandoned &&
                (mode !== 'cc' || expense?.status === ExpenseStatusValuesEnum.Approved),
        });
    }, [expense?.status]);

    useEffect(() => {
        if (hasMounted.current) {
            const previousBillType = previousBillTypeRef.current;

            // Only trigger validation if both previous and current billType are non-null
            if (previousBillType && billType) {
                trigger(`expenseEntries[${index}].transactionDate`);
            }

            previousBillTypeRef.current = billType;
        } else {
            hasMounted.current = true;
            previousBillTypeRef.current = billType;
        }
    }, [billType]);

    return (
        <Grid2 size={{ xs: 12, md: 6 }}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].transactionDate`}
                defaultValue={expense.transactionDate || null}
                rules={{
                    validate: (value) => {
                        if (
                            required.required &&
                            validationMode !== ValidationModeEnum.Save &&
                            !value
                        ) {
                            return 'Service Date is required. Please enter a valid date.';
                        }
                        return true; // Passes in save mode
                    },
                }}
                render={({ onChange, value }) => (
                    <ExpenseDatePicker
                        disabled={isViewOnly}
                        onChange={(e) => {
                            onChange(e);
                            handleDateChange(e);
                        }}
                        value={value ? moment(value) : null}
                        id={`service-date${index}`}
                        label="Service date"
                        required={required.required && !isMileage}
                        maxDate={moment()}
                        parentTextFieldProps={{
                            error: Boolean(errors.expenseEntries?.[index]?.transactionDate),
                            helperText: errors.expenseEntries?.[index]?.transactionDate?.message,
                        }}
                        parentSx={{
                            '& .MuiInputBase-root': {
                                borderColor: !errors.expenseEntries?.[index]?.transactionDate
                                    ? 'default'
                                    : `${COLORS.LT_PEPPER} !important`,
                            },
                        }}
                    />
                )}
            />
        </Grid2>
    );
};

export default ExpenseServiceDate;
